import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

class PdfExportUtils {
  static exportToPdf(columns: any[], visibleRows: any[], tabName: string, fileName: string): void {
    const headers = columns.map((col: any) => col.Header);

    const data = visibleRows.map((row: any) => {
      if (!row) {
        return Array(columns.length).fill("");
      }

      return columns.map((col: any) => {
        const value = row[col.accessor];
        return value !== undefined ? value : "";
      });
    });

    const doc = new jsPDF({
      orientation: columns.length > 8 ? "landscape" : "portrait",
      unit: "mm",
      format: "a4",
    });

    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.text(tabName, 14, 15);

    autoTable(doc, {
      head: [headers],
      body: data,
      startY: 25,
      styles: {
        fontSize: 8,
        cellPadding: 2,
        overflow: "linebreak",
        cellWidth: "wrap",
      },
      headStyles: {
        fillColor: [41, 128, 185],
        textColor: 255,
        fontStyle: "bold",
      },
      alternateRowStyles: { fillColor: [245, 245, 245] },
      margin: { top: 25, left: 10, right: 10 },
    });

    doc.save(fileName);
  }
}

export default PdfExportUtils;
